exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[dir] .PopoverContent_popOverContainer__36Xkt{padding:.8rem 1.2rem}.PopoverContent_popOverContent__2x6cI{font-size:1.4rem;letter-spacing:.03rem;color:#444f5c}", ""]);

// Exports
exports.locals = {
	"popOverContainer": "PopoverContent_popOverContainer__36Xkt",
	"popOverContent": "PopoverContent_popOverContent__2x6cI"
};